const DEFAULT_API_PROTOCOL = "http";
const DEFAULT_API_PORT = "3000";
const DEFAULT_CABLE_PROTOCOL = "ws";

function compactEnv(value) {
  if (value === undefined || value === null) return null;

  const compacted = value.trim();
  if (compacted === "undefined" || compacted === "null") return null;

  return compacted || null;
}

function envDefined(value) {
  if (value === undefined || value === null) return false;

  const compacted = value.trim();

  return compacted !== "undefined" && compacted !== "null";
}

function envPort(value, defaultPort = null) {
  if (!envDefined(value)) return defaultPort;

  return value.trim();
}

function cablePort() {
  if (envDefined(process.env.VUE_APP_CABLE_PORT)) {
    return envPort(process.env.VUE_APP_CABLE_PORT);
  }

  if (envDefined(process.env.VUE_APP_API_PORT)) {
    return envPort(process.env.VUE_APP_API_PORT);
  }

  return DEFAULT_API_PORT;
}

function stripTrailingSlash(value) {
  return value.replace(/\/$/, "");
}

function normalizeProtocol(protocol) {
  return protocol.endsWith(":") ? protocol : `${protocol}:`;
}

function browserHostname() {
  return window.location.hostname;
}

export function buildHostPortUrl({ protocol, host, port }) {
  const portPart = port ? `:${port}` : "";

  return `${normalizeProtocol(protocol)}//${host}${portPart}`;
}

export function getApiBaseUrl() {
  const configuredUrl = compactEnv(process.env.VUE_APP_API_URL);

  if (configuredUrl) {
    return stripTrailingSlash(configuredUrl);
  }

  return buildHostPortUrl({
    protocol: DEFAULT_API_PROTOCOL,
    host: browserHostname(),
    port: envPort(process.env.VUE_APP_API_PORT, DEFAULT_API_PORT),
  });
}

export function getCableUrl(token = null) {
  const configuredUrl = compactEnv(process.env.CABLE_URL);
  const baseUrl =
    configuredUrl ||
    buildHostPortUrl({
      protocol: DEFAULT_CABLE_PROTOCOL,
      host: browserHostname(),
      port: cablePort(),
    }) + "/cable";

  if (!token) return baseUrl;

  const url = new URL(baseUrl);
  url.searchParams.set("token", token);

  return url.toString();
}
